
function scroll_effect() {
    var element = document.getElementsByClassName('scroll-up');
    if(!element) return;
                        
    var scrollY = window.pageYOffset;
    var windowH = window.innerHeight;
    var showTiming = 140; // 要素を表示するタイミング
    for(var i = 0; i < element.length; i++) { 
      var elemClientRect = element[i].getBoundingClientRect(); 
      var elemY = scrollY + elemClientRect.top; 
      if(scrollY > elemY - windowH + showTiming) {
        element[i].classList.add('is-show');
      }
    }
  }
  window.addEventListener('scroll', scroll_effect); // スクロール時に実行

jQuery.env = {
android: {
is: function () {
return navigator.userAgent.indexOf('Android') != -1;
},
version: function () {
return parseFloat((navigator.userAgent.match(/Android ([\d.]+)/) || [0, 0])[1]);
},
isMobile: function () {
return navigator.userAgent.indexOf('Mobile Safari') != -1;
},
},
ios: {
is: function () {
return navigator.userAgent.indexOf('iPhone') != -1 || navigator.userAgent.indexOf('iPod') != -1 || navigator.userAgent.indexOf('iPad') != -1;
},
version: function () {
return parseFloat((navigator.userAgent.match(/([\d_]+) like/) || [0, 0])[1].replace(/_/g, '.'));
},
isMobile: function () {
return navigator.userAgent.indexOf('iPhone') != -1 || navigator.userAgent.indexOf('iPod') != -1;
},
},
webkit: {
version: function () {
return parseFloat((navigator.userAgent.match(/AppleWebKit\/([\d.]+)/) || [0, 0])[1]);
},
},
};
var isMobile = jQuery.env.android.isMobile() || jQuery.env.ios.isMobile();

if (isMobile) {
// scroll animate
jQuery(function () {
jQuery('a[href*="#"]:not([href="#"])').click(function () {
if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
var target = jQuery(this.hash);
target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
if (target.length) {
jQuery('html, body').animate(
{
scrollTop: target.offset().top,
},
1000
);
// return false;
}
}
});
});
} else {
}
jQuery(window).on('load', function () {
jQuery('.slider').slick({
//スライドさせる
autoplay: true,
autoplaySpeed: 3000,
speed: 400,
infinite: true,
slidesToShow: 1,
slidesToScroll: 1,
fade: false,
dots: false,
arrows: false,
centerPadding: '0',
centerMode: true,
variableWidth: false,
});

function checkBreakPoint() {
w = jQuery(window).width();
if (w <= 767) {
// スマホ向け（767px以下のとき）
jQuery('.photo.onlysp').not('.slick-initialized').slick({
//スライドさせる
autoplay: true,
autoplaySpeed: 3000,
speed: 400,
infinite: true,
slidesToShow: 1,
slidesToScroll: 1,
fade: false,
dots: false,
arrows: true,
centerPadding: '0',
centerMode: true,
variableWidth: false,
prevArrow: '<img src="/pages/20231220_denim/images/prev.png" class="slide-arrow prev-arrow">',
nextArrow: '<img src="/pages/20231220_denim/images/next.png" class="slide-arrow next-arrow">',
});
} else {
// PC向け
jQuery('.photo.onlysp.slick-initialized').slick('unslick');
}
}
// ウインドウがリサイズする度にチェック
jQuery(window).resize(function () {
checkBreakPoint();
});
// 初回チェック
checkBreakPoint();
});
jQuery.env = {
android: {
is: function () {
return navigator.userAgent.indexOf('Android') != -1;
},
version: function () {
return parseFloat((navigator.userAgent.match(/Android ([\d.]+)/) || [0, 0])[1]);
},
isMobile: function () {
return navigator.userAgent.indexOf('Mobile Safari') != -1;
},
},
ios: {
is: function () {
return navigator.userAgent.indexOf('iPhone') != -1 || navigator.userAgent.indexOf('iPod') != -1 || navigator.userAgent.indexOf('iPad') != -1;
},
version: function () {
return parseFloat((navigator.userAgent.match(/([\d_]+) like/) || [0, 0])[1].replace(/_/g, '.'));
},
isMobile: function () {
return navigator.userAgent.indexOf('iPhone') != -1 || navigator.userAgent.indexOf('iPod') != -1;
},
},
webkit: {
version: function () {
return parseFloat((navigator.userAgent.match(/AppleWebKit\/([\d.]+)/) || [0, 0])[1]);
},
},
};
var isMobile = jQuery.env.android.isMobile() || jQuery.env.ios.isMobile();

if (isMobile) {
// scroll animate
jQuery(function () {
jQuery('a[href*="#"]:not([href="#"])').click(function () {
if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
var target = jQuery(this.hash);
target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
if (target.length) {
jQuery('html, body').animate(
{
scrollTop: target.offset().top,
},
1000
);
// return false;
}
}
});
});
} else {
}

